var map = {
	"./number-1.svg": 716,
	"./number-2.svg": 717,
	"./number-3.svg": 718,
	"./number-4.svg": 719,
	"./number-5.svg": 720,
	"./number-6.svg": 721,
	"./number-7.svg": 722,
	"./number-8.svg": 723,
	"./number-9.svg": 724,
	"./number-shine-1.svg": 725,
	"./number-shine-2.svg": 726,
	"./number-shine-3.svg": 727,
	"./number-shine-4.svg": 728,
	"./number-shine-5.svg": 729,
	"./number-shine-6.svg": 730,
	"./number-shine-7.svg": 731,
	"./number-shine-8.svg": 732,
	"./number-shine-9.svg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;